import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from './AuthLayoutContainer.css';

export const AuthLayoutContainer = ({ className, children, ...other }) => (<div
    className={cx(styles.box, className)}
    {...other}
>
    {children}
</div>);

AuthLayoutContainer.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};

export default AuthLayoutContainer;



// WEBPACK FOOTER //
// ./src/client/Components/AuthLayoutContainer/AuthLayoutContainer.js